import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const SEEN_KEY = "cg_intro_seen";

export const IntroVideo = () => {
  const [show, setShow] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SEEN_KEY)) return;
    let mounted = true;
    api
      .get("/intro-video")
      .then((r) => {
        if (mounted && r.data?.active) setShow(true);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem(SEEN_KEY, "1");
    const t1 = setTimeout(() => setClosing(true), 3500);
    const t2 = setTimeout(() => setShow(false), 4450);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [show]);

  const skip = () => {
    setClosing(true);
    setTimeout(() => setShow(false), 900);
  };

  if (!show) return null;

  return (
    <div
      className={`cg-intro ${closing ? "cg-intro--closing" : ""}`}
      data-testid="intro-overlay"
      onClick={skip}
      role="button"
      aria-label="Saltar introducción"
    >
      <div className="cg-intro__door cg-intro__door--top" />
      <div className="cg-intro__door cg-intro__door--bottom" />
      <div className="grain cg-intro__grain" />

      <div className="cg-intro__content" data-testid="intro-content">
        <div className="cg-intro__badge" data-testid="intro-badge">
          <span className="cg-intro__spark" />
          <span className="font-display">CG</span>
        </div>
        <div className="cg-intro__title-wrap">
          <div className="cg-intro__title font-display">CIUDAD GARAJE</div>
        </div>
        <div className="cg-intro__sub overline">Cervecería Independiente · Est. 2024</div>
        <div className="cg-intro__bar">
          <span />
        </div>
      </div>

      <button className="cg-intro__skip" data-testid="intro-skip" onClick={skip}>
        Saltar ✕
      </button>
    </div>
  );
};
